<template>
  <div class="upload-draft-app-icon">
    <DroppableImageSelector
      v-loading="loading"
      class="upload-draft-app-icon__picker"
      accept=".png"
      :image="localImage"
      @change="uploadIcon"
    />

    <ErrorsList
      class="upload-draft-app-icon__errors"
      :errors="uploadErrors"
      error-guide=""
    />
  </div>
</template>

<script>
import { DraftApps } from '@/api/api';
import DroppableImageSelector from '@@/common/file-selectors/DroppableImageSelector';
import ErrorsList from '@@/common/ErrorsList';

export default {
  name: 'UploadDraftAppIcon',
  components: { DroppableImageSelector, ErrorsList },
  props: {
    icon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      uploadErrors: [],
      loading: false,
      localImage: null,
    };
  },
  watch: {
    icon: {
      immediate: true,
      handler(icon) {
        this.localImage = icon;
      },
    },
  },
  methods: {
    uploadIcon(icon) {
      const id = this.$route.params.appId;
      this.loading = true;

      return DraftApps.uploadIcon({ id, icon })
        .then(({ message, url }) => {
          if (message) this.$message.success(message);
          this.localImage = url;
        })
        .catch(({ message, errors = [] }) => {
          this.uploadErrors = errors;
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.upload-draft-app-icon {
  &__picker {
    height: rem-calc(290px);

    @include breakpoint(medium down) {
      height: rem-calc(200px);
    }
  }

  &__errors {
    margin-top: $global-margin;
  }
}
</style>
